

export function getBaseUrl() {
    return 'https://materialliggare.kitscontractor.se/api'; // PROD
    //return 'http://constructor.app.dev.hexastudio.se/api'; // DEV
    //return 'http://localhost:8080/api'
}
